import axios from 'axios'
import { get as getProp } from 'object-path'
import { SESSION_VARS } from "@/global/constants";
import { getPathView, isExcludedPath, isRoutesDifferent } from "./utils/axios-helper";
import { TOAST_TYPES, toastService } from "./global/toast";

// Lista de rutas que no deberían redirigir al login en caso de error 401/403
export const NON_REDIRECTABLE_AUTH_ERROR_PATHS = ['/view/login', '/view/new/password'];

const AxiosConfig = axios.create({ baseURL: process.env.VUE_APP_URL })

AxiosConfig.interceptors.request.use((request) => {
  const isLocal = location.hostname === 'localhost'
  const storedToken = localStorage.getItem(SESSION_VARS.TOKEN)
  const currentCompany = localStorage.getItem(SESSION_VARS.CURRENT_COMPANY)
  const token = isLocal && !storedToken ? process.env.VUE_APP_TOKEN : storedToken || "";
  let pathView = getPathView()
  const isDifferent = isRoutesDifferent(pathView, location.pathname);
  if (isDifferent && pathView === '/') {
    pathView = location.pathname;
  }

  request.headers.Authorization = token;
  request.headers.pathView = pathView;

  if (currentCompany) {
    request.headers.companyId = currentCompany;
  }

  if (isLocal) {
    request.headers["Access-Control-Allow-Origin"] = "*";
    request.headers["Access-Control-Allow-Headers"] = "*";
    request.headers["Access-Control-Allow-Credentials"] = "true";
    request.headers["Access-Control-Allow-Methods"] = "*";
  }

  return request;
});

AxiosConfig.interceptors.response.use(
  response => {
    const newToken = response.headers['authorization']
    if (newToken) {
      localStorage.setItem(SESSION_VARS.TOKEN, newToken)
      localStorage.setItem('x-token-received', Date.now())
      typeof window !== 'undefined' && (window.__tokenRefreshedThisCycle = false);
    }
    return response;
  },
  error => {
    console.log('Error completo:', error);
    const errorResponse = error.response;
    const statusCode = errorResponse ? errorResponse.status : getProp(error, 'response.status');

    if (errorResponse) {
      console.log('Código de estado:', statusCode);
    }

    const is401 = statusCode === 401;
    const is403 = statusCode === 403;

    if (is401 && !isExcludedPath()) {
      console.log('Redirigiendo a login debido a error de autenticación (401)');

      const errorMessage = errorResponse && errorResponse.data && errorResponse.data.message
        ? errorResponse.data.message
        : 'Sesión expirada';
      console.log('Detalles del error 401:', errorMessage);

      clearSession()
      console.log('Redirigiendo a login');
      location.href = '/view/login';
    }

    if (is403) {
      const errorMessage = errorResponse && errorResponse.data && errorResponse.data.message
        ? errorResponse.data.message
        : 'No tienes permisos';
      toastService.openToast(errorMessage, TOAST_TYPES.ERROR)
    }

    return Promise.reject(error);
  }
);

export const clearSession = () => {
  localStorage.removeItem(SESSION_VARS.TOKEN)
  localStorage.removeItem(SESSION_VARS.CURRENT_COMPANY)
  localStorage.removeItem(SESSION_VARS.USERNAME)
  localStorage.removeItem(SESSION_VARS.EMAIL)
  localStorage.removeItem('x-token-received')
}

export default AxiosConfig
